import { MapPin, Calendar, Armchair } from 'lucide-react';

export const HowItWorks = () => {
  const steps = [
    {
      icon: MapPin,
      title: 'Elige origen y destino',
      description: 'Selecciona las ciudades entre las que deseas viajar',
    },
    {
      icon: Calendar,
      title: 'Selecciona fecha',
      description: 'Escoge el día que mejor se adapte a tu itinerario',
    },
    {
      icon: Armchair,
      title: 'Reserva tu asiento',
      description: 'Confirma tu compra y recibe tu boleto al instante',
    },
  ];

  return (
    <section className="py-24 bg-[#F7F8FA]">
      <div className="max-w-[1440px] mx-auto px-8">
        <div className="text-center mb-20">
          <h2 className="mb-4">Cómo funciona</h2>
          <p className="text-[#6B7280] text-lg max-w-2xl mx-auto">
            Compra tus boletos de autobús en tres simples pasos
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-5xl mx-auto relative">
          {/* Dotted connector line - hidden on mobile */}
          <div className="hidden md:block absolute top-16 left-0 right-0 h-0.5 border-t-2 border-dotted border-[#E5E7EB] -z-10" 
               style={{ left: '16.66%', right: '16.66%' }}>
          </div>

          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="text-center">
                {/* Icon Card */}
                <div className="inline-flex items-center justify-center w-32 h-32 bg-white rounded-[16px] border border-[#E5E7EB] shadow-sm mb-8 relative z-10">
                  <div className="w-16 h-16 bg-[#FFF5F0] rounded-[14px] flex items-center justify-center">
                    <Icon className="w-8 h-8 text-[#FF6A2A]" />
                  </div>
                </div>
                
                {/* Content */}
                <h3 className="mb-3">{step.title}</h3>
                <p className="text-[#6B7280] leading-relaxed">
                  {step.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};